// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__tqPHa","row":"styles_row__7RBcU","itemImage":"styles_itemImage__GLGYE"};